import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import '@fontsource/be-vietnam-pro/400.css';
import '@fontsource/be-vietnam-pro/500.css';
import '@fontsource/be-vietnam-pro/600.css';
import '@fontsource-variable/lora';
import '@fontsource-variable/lora/wght-italic.css';
import './styles.css';
import './styles/world.css';
import './styles/look.css';
import './styles/gift.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
